import { ItemModel } from '../models/ItemModel';
import { Table } from '../Table/Table';

import { ProductTableConfig, ProductTableContext } from './components/ProductTableContext';
import { TableContent } from './components/TableContent';
import { TableHeaderRow } from './components/TableHeaderRow';

interface Config extends ProductTableConfig {
    initialItems: ItemModel[];
}

interface FormikProductTableProps {
    config: Config;
}

export const FormikProductTable = ({ config }: FormikProductTableProps) => {
    return (
        <ProductTableContext.Provider value={config}>
            <Table>
                <thead>
                    <TableHeaderRow />
                </thead>
                <tbody>
                    <TableContent />
                </tbody>
            </Table>
        </ProductTableContext.Provider>
    );
};
